import { useQuery } from "@tanstack/react-query";
import { SpendInsightsCompanies } from "api/schema/insights/spendInsightsCompaniesSchema";
import { usePublicApiService } from "contexts/PublicApiServiceProvider";

interface QueryParams {
  page: number;
  pageSize: number;
  query: string;
}

interface QueryOptions {
  enabled: boolean;
  queryParams: QueryParams;
}

export const spendInsightsCompaniesKeys = {
  all: ["getSpendInsightsCompanies"],
  search: (queryParams: QueryParams) => [
    ...spendInsightsCompaniesKeys.all,
    queryParams,
  ],
};

export const useSpendInsightsCompanies = ({
  enabled,
  queryParams,
}: QueryOptions) => {
  const publicApi = usePublicApiService();
  const { page, pageSize, query: searchQuery } = queryParams;
  const query = {
    pageSize,
    page,
    query: searchQuery && `id~${searchQuery}||name~${searchQuery}`,
    orderBy: "-created",
  };

  return useQuery<SpendInsightsCompanies>({
    enabled,
    staleTime: Infinity,
    queryKey: spendInsightsCompaniesKeys.search(query),
    queryFn: () => publicApi.getSpendInsightsCompanies({ query }),
    throwOnError: true,
    refetchOnWindowFocus: "always",
  });
};
